module.exports = __webpack_public_path__ + "img/data-solution.f011396a.svg";